"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("./utils");
const SVGCircle = ({ radius, color }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", { viewBox: "-5 -5 110 110", className: "SVGCircle" },
            react_1.default.createElement("path", { fill: "none", stroke: `${color}`, strokeWidth: "8", d: (0, utils_1.describeArc)(50, 50, 48, 0, radius) }))));
};
exports.default = SVGCircle;
//# sourceMappingURL=index.js.map